var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControlLabel, Switch } from "@mui/material";
import { useEventPresentation } from "@/hooks/useZonedFormat";
import { isSealAtClose } from "@/services/ballotBoxSealPolicy";
import { BallotBoxesCard } from "./BallotBoxesCard";
/** Where the viewer's choice is remembered, in this browser only. */
export var BALLOT_BOXES_VISIBLE_KEY = "dashboard.ballotBoxes.visible";
/** Whether the Ballot boxes card is shown under the monitoring dashboards. */
export var EBallotBoxesVisibility;
(function (EBallotBoxesVisibility) {
    EBallotBoxesVisibility["SHOWN"] = "shown";
    EBallotBoxesVisibility["HIDDEN"] = "hidden";
})(EBallotBoxesVisibility || (EBallotBoxesVisibility = {}));
/** The remembered choice; shown unless hidden was stored and can be read. */
var readVisibility = function () {
    try {
        return window.localStorage.getItem(BALLOT_BOXES_VISIBLE_KEY) ===
            EBallotBoxesVisibility.HIDDEN
            ? EBallotBoxesVisibility.HIDDEN
            : EBallotBoxesVisibility.SHOWN;
    }
    catch (_a) {
        return EBallotBoxesVisibility.SHOWN;
    }
};
/** Remembers the choice; a blocked storage keeps it for this view only. */
var writeVisibility = function (visibility) {
    try {
        window.localStorage.setItem(BALLOT_BOXES_VISIBLE_KEY, visibility);
    }
    catch (_a) {
        // Not remembered: the next visit shows the ballot boxes again.
    }
};
/**
 * The Ballot boxes card under a Post's monitoring dashboards, with a switch
 * that hides it. Shown by default; the choice is remembered per viewer in
 * this browser. Nothing is shown when the event doesn't seal its ballot boxes.
 */
export var BallotBoxesSection = function (props) {
    var t = useTranslation().t;
    var presentation = useEventPresentation(props.electionEventId);
    var _a = useState(readVisibility), visibility = _a[0], setVisibility = _a[1];
    if (!isSealAtClose(presentation))
        return null;
    var shown = visibility === EBallotBoxesVisibility.SHOWN;
    var onChange = function (checked) {
        var next = checked ? EBallotBoxesVisibility.SHOWN : EBallotBoxesVisibility.HIDDEN;
        setVisibility(next);
        writeVisibility(next);
    };
    return (_jsxs(Box, { children: [_jsx(FormControlLabel, { control: _jsx(Switch, { checked: shown, onChange: function (event) { return onChange(event.target.checked); } }), label: t("dashboard.ballotBoxes.show") }), shown ? _jsx(BallotBoxesCard, __assign({}, props)) : null] }));
};
export default BallotBoxesSection;
